<div class="product_dashboard custom-scrollv2">
<div class="row row-boxcolumn">
    <div class="col-lg-6">
        <div class="dashboard_card-box">
            <div class="d-flex justify-content-end mb-2">
                <app-date-component-renderer [isGraphDataChange]="false" [currentDateFilter]="currentDateFilter"></app-date-component-renderer>
            </div>

            <div class="summarychartBox" *ngIf="!graphLoading && graphSummary">                                     
                <div class="chart-circle">
                    <div class="donut-inner">
                        <span>Total Orders :</span>
                        <h5>{{ totalCount | number}}</h5>
                        <span>Qty Sold :</span>
                        <h5>{{ totalQtySold | number}}</h5>
                    </div>
                    <div class="position-relative z-2">
                   <div id="netyard" style="height: 180px; width: 100%; margin-top: -24px;">
                        <app-doughnut-chart [id]="'netyard'" [data]="productRes.chartData" [isProductDashboard]="true" [chartColors]="productRes.chartColors"
                           ></app-doughnut-chart>
                    </div>
                    </div>                   
                </div>

                <ul class="list_value" *ngIf="graphSummary?.length !== 0">
                    <ng-container *ngFor="let item of graphSummary">                       
                        <li>
                            <div class="list_value_box">
                                <div class="divider" [ngStyle]="{'background-color': item.color}"></div>
                                <div class="detail d-flex flex-column text-start">
                                    <strong class="value">{{item.orders | number}}</strong>
                                    <span class="value_text">orders</span>
                                </div>
                                <div class="detail d-flex flex-column text-start ms-2">
                                    <strong class="value">{{item.qty | number}}</strong>
                                    <span class="value_text">qty</span>
                                </div>
                                <div class="value_text ms-auto">{{item.name}}</div>
                                <div class="icon ms-2"> <img src="assets/images/account-dropdown/{{item.type | lowercase }}.png" class="img-fluid" /></div>
                            </div>
                        </li>
                    </ng-container> 
                </ul>
            </div>
            <div class="loader" *ngIf="graphLoading">
                <img  src="assets/images/nineyard-loading.gif" >
            </div>
        </div>
    </div>
    <div class="col-lg-6">
        <div class="dashboard_card-box">
            <div  *ngIf="salesData">
                <h3 class="title-text">Inventory Value</h3>
                <ul class="list_value">
                    <ng-container>
                        <li>
                            <div class="list_value_box">
                                <strong class="value">{{salesData.inventoryValue | currency}}</strong>
                                <span class="value_text">Inventory value</span>
                            </div>
                        </li>
                        <li>
                            <div class="list_value_box">
                                <strong class="value">{{salesData.suggestedPoValue | currency}}</strong>
                                <span class="value_text">Suggested PO value</span>
                            </div>
                        </li>
                        <li>
                            <div class="list_value_box">
                                <strong class="value">{{salesData.onPoValue | currency}}</strong>
                                <span class="value_text">On PO value</span>
                            </div>
                        </li>                       
                    </ng-container>
                </ul>
            </div>
            <div class="loader" *ngIf="!salesData">
                <img  src="assets/images/nineyard-loading.gif" >
            </div>
        </div>
    </div>
    <!-- <div class="col-lg-4">
        <div class="dashboard_card-box">
            <div>
                <h3 class="title-text">Profit for company (%)</h3>
                <ul class="list_value">
                    <ng-container>
                        <li>
                            <div class="list_value_box py-2">
                               
                                <strong class="value">0%</strong>
                                <span class="value_text">Profit Markup</span>
                            </div>
                        </li>
                        <li>
                            <div class="list_value_box py-2">
                               
                                <strong class="value">0%</strong>
                                <span class="value_text">Profit Margin</span>
                            </div> 
                        </li>
                    </ng-container>
                </ul>

                <ul class="list_table">
                    <li class="row_title">Profit Breakdown </li>
                     
                    <li>Cost <span>$0.00</span></li>
                    
                    <li>FBA Fees <span>$0.00</span></li>
                   
                    <li>Shipping Fee <span>$0.00</span></li>
                    
                    <li class="row_total">Total profit <span> $0.00</span></li>
                </ul>
            </div>
            
            <div class="pop_up_div">
                <div class="overlay-profit"></div>
                <div class="pop_up_content">Coming Soon!</div>
            </div>
        </div>
    </div> -->
</div>
<div class="row row-collectiongraph">
    <div class="col-sm-12 h-100">
        <div class="dashboard_card-box collection-graph">
            <app-shipment-collection-graph [height]="246" [isProductDashBoard]="true" [graphStats]="graphStats" [graphData]="graphData" [id]="'productDashboardLineChart'"  [chartData]="dashboardGrpahData" [chartColors]="lineColor" [type]="'spline'" [tickInterval]="tickInterval" [labels]="graphLabel"></app-shipment-collection-graph> 
        
        </div>
    </div>
</div>
</div>